export const faqNav = [
    {
        label: "Личный кабинет WAY2WEI",
        block: "mainBlock",
    },
    {
        label: "Регистрация и вход",
        block: "authBlock",
    },
    {
        label: "Сотрудники и группы",
        block: "staffGroupsBlock",
    },
    {
        label: "Оценка и развитие",
        block: "assessmentDevBlock",
    },
    {
        label: "Управление доступами",
        block: "accessControlBlock",
    },
    {
        label: "Работа с заказами",
        block: "ordersBlock",
        children: [
            {
                label: "Создание заказа",
                section: "order-create",
            },
        ],
    },
    {
        label: "Настройка уведомлений",
        block: "notificationsBlock",
    },
    {
        label: "Отчёты и аналитика",
        block: "reportsBlock",
        children: [
            {
                label: "Сотрудники и группы",
                section: "staff-groups",
            },
            {
                label: "Оценка и развитие",
                section: "assessment",
            },
            {
                label: "Финансовые отчёты",
                section: "finance",
            },
        ],
    },
    {
        label: "Финансовые операции",
        block: "financeBlock",
    },
    {
        label: "Настройки аккаунта",
        block: "accountSettingsBlock",
    },
    {
        label: "Поддержка и помощь",
        block: "supportBlock",
    },
];